import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles(() => ({
  reordering: {
    "& .drag-hide": {
      display: "none",
    }
  },
  grid: {
    display: "grid",
    gridTemplateRows: "1fr",
  },
  flexbox: {
    display: "flex",
  },
  columnFlexbox: {
    display: "flex",
    flexDirection: "column",
  },
}));

export default useStyle;
